<template>
	<div>
		<v-card
			v-for="(categoryProducts, category) in groupsProducts"
			:key="'category_' + category"
			flat
			color="transparent"
		>
			<v-card-title primary-title>
				{{ category }}
				<v-spacer></v-spacer>

				<v-btn class="ml-3" @click="addProduct()" small>
					Add Product
				</v-btn>
			</v-card-title>
			<v-card-text>
				<CatalogueProductsSortableComponent
					:catalogue_products="categoryProducts"
					:category="category.replace(/[^A-Z0-9]/gi, '_')"
					@editProduct="editProduct"
				></CatalogueProductsSortableComponent>
			</v-card-text>
		</v-card>

		<v-dialog v-model="productDialog" width="500">
			<ValidationObserver ref="productObs" v-slot="{ invalid }">
				<v-card>
					<v-card-title class="text-h5 grey lighten-2">
						{{
							product.product_name
								? "Edit Product"
								: "Add Product"
						}}
					</v-card-title>

					<v-card-text>
						<v-container grid-list-md>
							<v-layout row wrap>
								<v-flex xs12 md12 v-if="product.product_name">
									<ValidationProvider
										name="product_name"
										rules="required"
										v-slot="{ errors }"
									>
										<v-text-field
											label="Name"
											v-model="product.product_name"
											:error-messages="errors"
											readonly
										></v-text-field>
									</ValidationProvider>
								</v-flex>
								<v-flex xs12 md12>
									<ValidationProvider
										name="price"
										rules="required|min:0"
										v-slot="{ errors }"
									>
										<v-text-field
											label="Price"
											v-model="product.price"
											:error-messages="errors"
											type="number"
											step="0.01"
										></v-text-field>
									</ValidationProvider>
								</v-flex>
								<v-flex xs12 md12>
									<ValidationProvider
										name="sale_price"
										rules="min:0"
										v-slot="{ errors }"
									>
										<v-text-field
											label="Sale Price"
											v-model="product.sale_price"
											:error-messages="errors"
											type="number"
											step="0.01"
										></v-text-field>
									</ValidationProvider>
								</v-flex>
								<v-flex xs12 md12>
									<v-switch
										v-model="product.active"
										label="Is Active"
									></v-switch>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card-text>

					<v-divider></v-divider>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="error" text @click="closeProduct()">
							Close
						</v-btn>
						<v-btn
							color="primary"
							:disabled="invalid"
							:loading="product.processing"
							@click.native="submitProduct()"
						>
							Submit
						</v-btn>
					</v-card-actions>
				</v-card>
			</ValidationObserver>
		</v-dialog>
	</div>
</template>

<script>
import CatalogueProductsSortableComponent from "@Shop/components/CatalogueProductsSortableComponent.vue";
export default {
	components: {
		CatalogueProductsSortableComponent,
	},

	props: ["catalogue_products"],

	data() {
		return {
			productDialog: false,
			product: this.$inertia.form({
				id: null,
				product_name: null,
				product_id: null,
				price: null,
				sale_price: null,
				active: null,
				sort_order: null,
			}),
			products: this.catalogue_products,
		};
	},

	computed: {
		groupsProducts() {
			// Group products by category_name
			return this.products.reduce((acc, product) => {
				if (!acc[product.category_name]) {
					acc[product.category_name] = [];
				}
				acc[product.category_name].push(product);
				return acc;
			}, {});
		},
	},

	methods: {
		addProduct() {
			this.product = this.$inertia.form({
				id: null,
				product_name: null,
				product_id: null,
				price: null,
				sale_price: null,
				active: null,
				sort_order: null,
			});
			this.productDialog = true;
		},

		editProduct(product) {
			this.product = this.$inertia.form(product);
			this.productDialog = true;
		},

		submitProduct() {
			this.product.put(
				this.$route("tenant.catalogue_products.update", {
					tenant: this.$page.props.tenant.id,
					id: this.product.id,
				}),
				{
					preserveState: (page) =>
						page.props.flash.error ||
						Object.keys(page.props.errors).length > 0,
					preserveScroll: true,
				}
			);
			this.stepper = 2;
		},

		closeProduct() {
			this.productDialog = false;
		},
	},
};
</script>